import {HeroAccent, HeroContent, HeroCta, HeroSubtitle, HeroTag, HeroTitle} from "./index";

/**
 * Tag variant → i18n key mapping. Variants must match the values supported by
 * BannerTag/HeroTag. Banners stored without a tag (or with an unknown variant)
 * render no tag pill.
 */
const TAG_LABEL_KEYS = {
  promo: "homeHeroTagPromo",
  nuevo: "homeHeroTagNew",
  drop: "homeHeroTagDrop",
  torneo: "homeHeroTagTournament",
  race: "homeHeroTagRace",
};

/**
 * Default fallbacks for the CTA label and target. Pages can override the CTA
 * defaults via the optional second argument.
 */
const DEFAULTS = {
  ctaLabel: "Jugar Ahora",
  ctaHref: "/games",
};

/**
 * Build a `<HeroBanner>`-compatible slide from a backend Carrousel banner.
 *
 * @param {object} banner - Banner record from `webBanners`.
 * @param {object} [opts]
 * @param {(key: string, opts?: object) => string} opts.t - i18next translator.
 * @param {string} [opts.defaultCtaLabel] - Override default CTA label text.
 * @param {string} [opts.defaultCtaHref] - Override default CTA target.
 */
export const buildBannerSlide = (banner, opts = {}) => {
  const {t = (_key, o) => o?.defaultValue ?? "", defaultCtaLabel, defaultCtaHref} = opts;
  const bannerId = banner.ID || banner.id;
  const link = banner.web_link || banner.mobile_link;
  const ctaHref = link && link !== "#" ? link : (defaultCtaHref ?? DEFAULTS.ctaHref);
  const ctaLabel =
    banner.cta_label && banner.cta_label.trim().length > 0
      ? banner.cta_label
      : t("homeHeroCtaPlay", {defaultValue: defaultCtaLabel ?? DEFAULTS.ctaLabel});
  const tagKey = banner.tag && TAG_LABEL_KEYS[banner.tag] ? banner.tag : null;
  const tagLabel = tagKey ? t(TAG_LABEL_KEYS[tagKey]) : null;

  return {
    bgImage: bannerId,
    content: (
      <HeroContent key={bannerId}>
        {tagKey && tagLabel && (
          <HeroTag
            variant={tagKey}
            label={tagLabel}
          />
        )}
        {banner.title && (
          <HeroTitle>
            <HeroAccent>{banner.title}</HeroAccent>
          </HeroTitle>
        )}
        {banner.subtitle && <HeroSubtitle>{banner.subtitle}</HeroSubtitle>}
        <HeroCta
          label={ctaLabel}
          href={ctaHref}
        />
      </HeroContent>
    ),
  };
};
